export class RequestActionFilter {

    RequestID?: Number;
    DateStart?: Date;
    DateEnd?: Date;
    Take?: number;
}

export default RequestActionFilter;